"use strict";

var $ = require("jquery");
import { navCategoriesSliderToSlide } from './_navCategoriesToSlide.js';

function navCategoriesDesktopBase() {

    const slide = $('.slide');

    $('.nav-slider-desktop-base a').each(function () {
        let parent_term = $(this);
        let parent_slug = parent_term.attr('data-target');
        let child_nav = $('.slide#' + parent_slug);

        parent_term.hover(function () {
            navCategoriesSliderToSlide(2);
            slide.removeClass('active');
            child_nav.addClass('active');
        });
    })
}

$(document).ready(function () {
    navCategoriesDesktopBase();
});